export default {
  data() {
    return {
      msgRegex: {
        minLength: /^minLength\d+$/,
        maxLength: /^maxLength\d+$/,
        exactValue: /^exactLength\d+$/,
        minValue: /^minValue\d+$/,
        maxValue: /^maxValue\d+$/
      }
    }
  },
  computed: {
    errorTrans() {
      return {
        serverError: this.$gettext('Chyba serveru'),
        formError: this.$gettext('Formulář není vyplněn správně')
      }
    },
    apiMessagesMap() {
      return {
        mustBePositive: this.$gettext('Vyplňte prosím kladné číslo.'),
        orderNumber: this.$gettext('Zadejte prosím kladné číslo, nulu nebo nechte prázdné.'),
        passwordRequiredForNewUser: this.$gettext('Zvolte si prosím heslo. Bez hesla není možné provést registraci.'),
        textFieldRequired: this.$gettext('Vyplňte prosím tuto hodnotu.'),
        selectFieldRequired: this.$gettext('Vyberte prosím hodnotu.'),
        showDoesNotExist: this.$gettext('Zvolený pořad nebyl v systému nalezen. Zkuste prosím akci provést znovu.'),
        episodeDoesNotExist: this.$gettext('Zvolená epizoda nebyla v systému nalezena. Zkuste prosím akci provést znovu.'),
        episodeDoesNotMatchShow: this.$gettext('Zvolená epizoda nepřísluší zvolenému pořadu.'),
        invalidImage: this.$gettext('Zkontrolujte prosím, zda nahráváte obrázek v platném formátu, a zkuste to znovu.'),
        mustBeNonNegatiove: this.$gettext('Vyplňte prosím kladné číslo nebo nulu.'),
        mustBeLowercase: this.$gettext('Toto pole může obsahovat pouze malá písmena.'),
        mustHaveDefaultBroadcastNameFormat: this.$gettext('Tato hodnota musí obsahovat "<from>" a "<to>".'),
        mustHaveImdbIdFormat: this.$gettext('Tato hodnota musí obsahovat předponu "tt" a následně 7 číslic.'),
        mustHaveTrailerFormat: this.$gettext('Tato hodnota musí začínat "https://www.youtube.com/"'),
        mustHaveEmailFormat: this.$gettext('Tato hodnota musí mít formát e-mailové adresy.'),
        isoCodeMustBeUnique: this.$gettext('Iso kód musí být unikátní.'),
        synonymMustBeUnique: this.$gettext('Synonymum musí být unikátní.'),
        showTranslationMustBeUnique: this.$gettext('Překlad pořadu musí být unikátní.'),
        pairingTemplateMustBeUnique: this.$gettext('Párovací šablona musí být unikátní.'),
        pairingTemplateRegexInvalid: this.$gettext('Regulární výraz párovací šablony musí být validní.'),
        selectPeriodicError: this.$gettext('Vyplňte prosím hodnotu periodicity.'),
        default: this.$gettext('Omlouváme se, nastala neočekávaná chyba'),
        onlyAzAndCommaAllowed: this.$gettext("Regiony mohou obsahovat pouze a-zA-Z a čárku jako oddělovač."),
        currencyFormatNotValid: this.$gettext('Formát není platný - musí obsahovat "#", "#.##" a nebo "#,##".'),
      }
    }
  },
  methods: {
    translateMsg(msg) {
      if (this.msgRegex.maxLength.test(msg)) {
        const limit = msg.match(/\d+/)[0]
        return this.$gettext('Zadejte prosím') + ` ${limit} ` + this.$gettext('nebo méně znaků.')
      } else if (this.msgRegex.minLength.test(msg)) {
        const limit = msg.match(/\d+/)[0]
        return this.$gettext('Zadejte prosím') + ` ${limit} ` + this.$gettext('nebo více znaků.')
      } else if (this.msgRegex.exactValue.test(msg)) {
        const limit = msg.match(/\d+/)[0]
        return this.$gettext('Zadejte hodnotu o') + ` ${limit} ` + this.$gettext('znacích.')
      } else if (this.msgRegex.maxValue.test(msg)) {
        const limit = msg.match(/\d+/)[0]
        return this.$gettext('Zadejte prosím hodnotu menší nebo rovnou') + ` ${limit}.`
      } else if (this.msgRegex.minValue.test(msg)) {
        const limit = msg.match(/\d+/)[0]
        return this.$gettext('Zadejte prosím hodnotu větší nebo rovnou') + ` ${limit}.`
      } else {
        return this.apiMessagesMap[msg] || msg || this.apiMessagesMap['default']
      }
    }
  }
}
